<script lang="ts" setup>
  withDefaults(
    defineProps<{
      size?: 'small' | 'medium' | 'large';
      title?: string;
    }>(),
    {
      size: 'large',
      dark: false,
      title: 'Carregando',
    },
  );
</script>

<template>
  <svg
    class="sol-inner-loader-page"
    :class="`icon-size-${size}`"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <title>{{ title }}</title>
    <path
      class="path"
      d="M16.0008 1.5C17.905 1.5 19.7905 1.87506 21.5497 2.60375C23.3089 3.33244 24.9074 4.4005 26.2538 5.74695C27.6003 7.0934 28.6684 8.69187 29.397 10.4511C30.1257 12.2103 30.5008 14.0958 30.5008 16C30.5008 17.9042 30.1257 19.7897 29.397 21.5489C28.6684 23.3081 27.6003 24.9066 26.2538 26.2531C24.9074 27.5995 23.3089 28.6676 21.5497 29.3963C19.7905 30.1249 17.905 30.5 16.0008 30.5C14.0966 30.5 12.2111 30.1249 10.4519 29.3963C8.69266 28.6676 7.09419 27.5995 5.74774 26.253C4.4013 24.9066 3.33323 23.3081 2.60454 21.5489C1.87585 19.7897 1.50079 17.9042 1.50079 16C1.5008 14.0958 1.87585 12.2103 2.60454 10.4511C3.33324 8.69187 4.4013 7.0934 5.74775 5.74695C7.0942 4.4005 8.69267 3.33244 10.4519 2.60375C12.2111 1.87505 14.0966 1.5 16.0008 1.5L16.0008 1.5Z" />
  </svg>
</template>

<style lang="scss">
  .sol-inner-loader-page {
    @apply stroke-2;
    @apply mx-auto;

    .path {
      @apply stroke-feedback-informative-pure;
      @apply stroke-cap-round origin-center;

      stroke-dashoffset: -10;
      animation: dash 1.2s ease-out infinite;

      &.-dark {
        @apply stroke-neutral-high-pure;
      }
    }
  }
</style>
